export default __webpack_public_path__ + "static/media/publish.33abd161.png";